(() => {
  'use strict';
  const root = document.querySelector('#MainContent[data-template*="raitooe-safety-v3"]');
  if (!root) return;

  const viewer = root.querySelector('[data-sv3-viewer]');
  const viewerImage = viewer?.querySelector('img');
  const viewerCaption = viewer?.querySelector('p');

  root.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const photo = target.closest('[data-sv3-photo]');
    if (photo && viewer && viewerImage && viewerCaption) {
      viewerImage.src = photo.dataset.sv3Photo;
      viewerImage.alt = photo.querySelector('img')?.alt || '';
      viewerCaption.textContent = photo.dataset.sv3Caption || '';
      viewer.showModal();
      return;
    }

    const close = target.closest('[data-sv3-viewer-close]');
    if (close) {
      viewer?.close();
      return;
    }

    const groupButton = target.closest('[data-sv3-record-toggle]');
    if (groupButton) {
      const group = groupButton.closest('[data-sv3-record-group]');
      const closed = group?.classList.toggle('is-collapsed') || false;
      groupButton.setAttribute('aria-expanded', String(!closed));
      const symbol = groupButton.querySelector('i');
      if (symbol) symbol.textContent = closed ? '+' : '−';
    }
  });

  viewer?.addEventListener('click', (event) => {
    if (event.target === viewer) viewer.close();
  });
})();
